import Section from "@/components/ui/section";
import React from "react";
import Image from "next/image";
export default function Testimonial({ data }) {
  return (
    data && (
      <Section className="mt-12 md:mt-0">
        <div className="flex md:flex-row md:items-center flex-col-reverse lg:gap-20 md:gap-12 gap-8 mx-auto lg:max-w-[817px] w-full">
          <div className="w-full flex flex-col gap-2">
            <div className="md:w-[88px] md:h-[80px] w-16 h-12 relative">
              <Image
                src={"/images/icons/quote.svg"}
                alt="about banner"
                sizes="(max-width: 479px) 500px, 100vw"
                fill
                className="w-full h-full object-contain"
              />
            </div>
            {data?.description && (
              <div
                className="font-light font-havletica lg:[&>p]:text-2xl [&>p]:text-xl text-darkGrey"
                dangerouslySetInnerHTML={{ __html: data?.description }}
              ></div>
            )}
            <div className="flex items-center gap-4 mt-4 md:mt-0">
              {data?.name && (
                <p className="lg:text-base text-sm font-light text-darkGrey/90 leading-none uppercase">
                  {data?.name}
                </p>
              )}
              {data?.designation && (
                <p className="text-[12px] text-darkGrey/90 leading-none">
                  {data?.designation}
                </p>
              )}
            </div>
          </div>
          <div className="md:w-[274px] w-full h-[274px] relative shrink-0">
            <Image
              src={
                data?.image?.data?.attributes?.url ?? "/images/placeholder.svg"
              }
              alt={data?.name ?? "testimonial image"}
              sizes="(max-width: 479px) 500px, 100vw"
              fill
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </Section>
    )
  );
}
